import { parseDate } from '#shared/utils'
import { test } from 'last-validator'

const MAX_DATE_LIMIT = 64092121200000

export const isInDateRange = test((value) => parseDate(value).getTime() < MAX_DATE_LIMIT, 'Chybný dátum.')
